"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var styled_components_1 = require("styled-components");
var ChartTitle = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 1.846rem;\n  letter-spacing: -0.01em;\n  margin-bottom: 1em;\n"], ["\n  font-size: 1.846rem;\n  letter-spacing: -0.01em;\n  margin-bottom: 1em;\n"])));
exports["default"] = ChartTitle;
var templateObject_1;
